module.exports = __webpack_public_path__ + "static/media/2.e1a23e80.png";